<div class="container-fluid py-2">

  <div class="row">
    <!-- Profile Card : compteurs calculés sur les séances réellement planifiées -->
    <div class="col-12 col-sm-12 col-md-12 col-lg-5 mb-4 order-1 order-lg-2">
      <app-profile-card [avatar]="currentUserAvatar" [name]="currentUserName"
        kind="professor"
        [points]="todaySessions().length" [statistics]="teacherStats()"
        [showButton]="true" [buttonText]="'CALENDAR.CREATE_BTN' | translate"
        [buttonLink]="'/teacher/calendar'"
        [customClasses]="'text-center bg-light border-0 py-1 px-1 br-9 h-100'">
        <div chart>
          <!-- Prochaines séances : la suite immédiate de l'emploi du temps -->
          <app-upcoming-sessions
            [sessions]="sessions()"
            [loading]="sessionsLoading()"
            [bare]="true"
            [limit]="5"
            calendarLink="/teacher/calendar"></app-upcoming-sessions>
        </div>
      </app-profile-card>
    </div>

    <!-- Colonne principale -->
    <div class="col-12 col-sm-12 col-md-12 col-lg-7 order-2 order-lg-1">
      <div class="mb-4">
        <!-- La quinzaine entière : les onglets « en cours » et « à venir »
             en dépendent, le seul jour les priverait de contenu. -->
        <app-today-classes
          [sessions]="sessions()"
          [loading]="sessionsLoading()"
          [errored]="sessionsErrored()"
          calendarLink="/teacher/calendar"></app-today-classes>
      </div>
    </div>
  </div>
</div>
